import { create } from 'zustand';
import { InvoiceListAgingBucket } from '@/types';
import { InvoiceSummaryBucketFilter } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-filters';

export const ALL_INVOICES_BUCKET_FILTER: InvoiceSummaryBucketFilter = {
  kind: 'allInvoices',
};

interface UnpaidInvoiceFilterStore {
  clearBucketFilter: () => void;
  selectAgingBucket: (overdueBucket: InvoiceListAgingBucket) => void;
  selectCreditMemos: () => void;
  selectedBucketFilter: InvoiceSummaryBucketFilter;
}

export const useUnpaidInvoiceFilterStore = create<UnpaidInvoiceFilterStore>()(
  (set) => ({
    clearBucketFilter: () =>
      set({ selectedBucketFilter: ALL_INVOICES_BUCKET_FILTER }),
    selectAgingBucket: (overdueBucket) =>
      set({ selectedBucketFilter: { kind: 'agingBucket', overdueBucket } }),
    selectCreditMemos: () =>
      set({ selectedBucketFilter: { kind: 'creditMemos' } }),
    selectedBucketFilter: ALL_INVOICES_BUCKET_FILTER,
  }),
);
